import React, { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LoginIcon from "@mui/icons-material/Login";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";


const StickyMenu = () => {
  const [open, setOpen] = useState(false);

  // Define icon data with labels, icons, links, and actions
  const icons = [
    {
      label: "Facebook",
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/cityplaza.jsr/",
    },
    {
      label: "Email",
      icon: <EmailIcon />,
      link: "mailto:info@hotelcityplazabd.com",
    },
    {
      label: "Login",
      icon: <LoginIcon />,
      link: "http://respos.icicle.site/login",
    },
    {
      label: "Location",
      icon: <LocationOnIcon />,
      action: () => setOpen(true),
    },
  ];

  return (
    <>
      {/* Sticky Sidebar Menu */}
      <Box
        sx={{
          position: "fixed",
          top: "40%",
          right: "10px", // Adjusted to place menu on the right
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          zIndex: 1000,
        }}
      >
        {icons.map((item, index) => (
          <Tooltip key={index} title={item.label} placement="left"> {/* Tooltip on the left side */}
            <IconButton
              onClick={item.action || undefined}
              href={item.link || undefined}
              target={item.link?.startsWith("mailto:") ? undefined : "_blank"}
              rel={item.link?.startsWith("mailto:") ? undefined : "noopener noreferrer"}
              sx={{
                backgroundColor: "#ffffff",
                color: "#008345",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#008345",
                  color: "#ffffff",
                  transform: "scale(1.1)",
                },
              }}
            >
              {item.icon}
            </IconButton>
          </Tooltip>
        ))}
      </Box>

      {/* Location Modal */}
      <Modal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "80%",
          height: "60%",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: 24,
          p: 2,
          position: "relative", // Enable absolute positioning for the close button
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "gray", // Close button color
            "&:hover": {
              color: "black",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" textAlign="center" sx={{color: 'black'}} gutterBottom>
          Hotel City Plaza International Location
        </Typography>
        <Box
          sx={{
            flex: 1,
            borderRadius: "8px",
            overflow: "hidden",
            height: "100%",
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3689.297972566445!2d89.2099292!3d23.16597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ff105e1e13502d%3A0xc84d539f8bf03316!2sHotel%20City%20Plaza%20International!5e0!3m2!1sen!2sbd!4v1679876543210"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Box>
      </Box>
    </Modal>
    </>
  );
};

export default StickyMenu;
